import axios from 'axios';
import { toast } from 'react-toastify';
import mock from "../pages/products/backendMock";
import config from "../config";
import { processImage, IMAGE_PRESETS } from '../utils/imageUtils';

import { RECEIVED_CATEGORIES, RECEIVED_PRODUCT_DEFAULTS } from './productCatalogTypes';
import { normalizeCategory, getProductsRequest } from './products';
import { DEFAULT_LANGUAGE, normalizeLanguage } from '../i18n/languages';

export { RECEIVED_PRODUCT_DEFAULTS };

async function normalizeUploadImage(picFile, preset = IMAGE_PRESETS.product) {
    if (!picFile) return picFile;
    const { file } = await processImage(picFile, preset);
    return file;
}

export const RECEIVING_STATIONS = 'RECEIVING_STATIONS';
export const RECEIVED_STATIONS = 'RECEIVED_STATIONS';
export const FAILURE_STATIONS = 'FAILURE_STATIONS';
export const UPDATING_STATIONS = 'UPDATING_STATIONS';
export const DELETING_STATIONS = 'DELETING_STATIONS';

export const RECEIVING_PICTURES = 'RECEIVING_PICTURES';
export const RECEIVED_PICTURES = 'RECEIVED_PICTURES';
export const FAILURE_PICTURES = 'FAILURE_PICTURES';
export const UPDATING_PICTURES = 'UPDATING_PICTURES';
export const DELETING_PICTURES = 'DELETING_PICTURES';

export const RECEIVING_VIDEOS = 'RECEIVING_VIDEOS';
export const RECEIVED_VIDEOS = 'RECEIVED_VIDEOS';
export const FAILURE_VIDEOS = 'FAILURE_VIDEOS';
export const UPDATING_VIDEOS = 'UPDATING_VIDEOS';
export const DELETING_VIDEOS = 'DELETING_VIDEOS';

export const RECEIVING_WEBSITES = 'RECEIVING_WEBSITES';
export const RECEIVED_WEBSITES = 'RECEIVED_WEBSITES';
export const FAILURE_WEBSITES = 'FAILURE_WEBSITES';
export const UPDATING_WEBSITES = 'UPDATING_WEBSITES';
export const DELETING_WEBSITES = 'DELETING_WEBSITES';

export const RECEIVING_STATION_SETTINGS = 'RECEIVING_STATION_SETTINGS';
export const RECEIVED_STATION_SETTINGS = 'RECEIVED_STATION_SETTINGS';
export const FAILURE_STATION_SETTINGS = 'FAILURE_STATION_SETTINGS';

export const RECEIVING_STORE_DETAILS = 'RECEIVING_STORE_DETAILS';
export const UPDATING_STORE_DETAILS = 'UPDATING_STORE_DETAILS';
export const RECEIVED_STORE_DETAILS = 'RECEIVED_STORE_DETAILS';
export const FAILURE_STORE_DETAILS = 'FAILURE_STORE_DETAILS';

export const UPDATING_PRODUCT_DEFAULTS = 'UPDATING_PRODUCT_DEFAULTS';
export const FAILURE_PRODUCT_DEFAULTS = 'FAILURE_PRODUCT_DEFAULTS';

async function getAvailableStations(merchantId) {
    const response = await axios.get(`/api/station/list/${merchantId}`);
    return response.data;
}

async function getStationById(stationId) {
    const response = await axios.get(`/api/station/${stationId}`);
    return response.data;
}

export function loadAvailableStations(merchantId) {
    return async (dispatch) => {
        dispatch(receivingStations());

        if (!merchantId) {
            dispatch(failtureStations('Merchant information is unavailable.'));
            return;
        }
        
        try {
            const data = await getAvailableStations(merchantId)
            if (data.status == 'Ok') {
                const payload = {
                    stations: data.stations
                }
                dispatch(receivedStations(payload));
            } else {
                dispatch(failtureStations(data.message));
            }
        } catch (error) {
            console.log(error);
            dispatch(failtureStations(error?.response?.data?.message || error.message || 'Failed to load stations'));
        }
    };
}

export function createStation(payload) {
    return async (dispatch) => {
        console.log(payload);

        dispatch(updatingStations());

        axios.post('/api/station/add', payload).then(async res => {
            console.log(res);
            if (res.data.status == "Error") {
                toast.error(res.data.message);
                dispatch(failtureStations(res.data.message));
            } else {
                const data = await getAvailableStations(payload.MerchantId);
                if (data.status == 'Ok') {
                    const station_payload = {
                        stations: data.stations
                    }
                    dispatch(receivedStations(station_payload));
                } else {
                    toast.error(data.message);
                    dispatch(failtureStations(data.message));
                }
                toast.success("A station has been created!");
            }
        })
    };
}

export function updateStation(payload) {
    return async (dispatch) => {
        dispatch(updatingStations());
        var stationId =  payload.StationId;

        var data = await getStationById(stationId)
        if (data.status == 'Ok') {
            var station = data.station;
            station.Name = payload.Name;

            axios.put('/api/station/update', station).then(async res => {
                if (res.data.status == "Error") {
                    toast.error(res.data.message);
                    dispatch(failtureStations(res.data.message));
                } else {
                    const data = await getAvailableStations(station.MerchantId);
                    if (data.status == 'Ok') {
                        const station_payload = {
                            stations: data.stations
                        }
                        dispatch(receivedStations(station_payload));
                    } else {
                        toast.error(data.message);
                        dispatch(failtureStations(data.message));
                    }
                    
                    toast.success("The station has been updated!");
                }
            })
        } else {
            dispatch(failtureStations(data.message));
        }
    };
}

export function deleteStation(stationId, merchantId) {
    return async (dispatch) => {
        dispatch(deletingStations(stationId));
        try {
            const res = await axios.delete(`/api/station/${stationId}`);
            if (res.data.status === 'Error') {
                toast.error(res.data.message);
                dispatch(failtureStations(res.data.message));
                return;
            }
            const data = await getAvailableStations(merchantId);
            if (data.status === 'Ok') {
                dispatch(receivedStations({ stations: data.stations }));
                toast.success('Station deleted.');
            } else {
                toast.error(data.message);
                dispatch(failtureStations(data.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to delete station.';
            toast.error(message);
            dispatch(failtureStations(message));
        }
    };
}

async function getStorePictures() {
    const response = await axios.get(`/api/assets/store/pictures`);
    return response.data;
}

async function getAssetById(assetId) {
    const response = await axios.get(`/api/assets/${assetId}`);
    return response.data;
}

export function loadPictures() {
    return async (dispatch) => {
        dispatch(receivingPictures());
        
        const data = await getStorePictures()
        if (data.status == 'Ok') {
            const payload = {
                pictures: data.pictures
            }
            dispatch(receivedPictures(payload));
        } else {
            toast.error(data.message);
            dispatch(failturePictures(data.message));
        }
    };
}

export function createPicture(payload) {
    return async (dispatch) => {
        
        dispatch(updatingPictures());

        const picFile = await normalizeUploadImage(payload.picFile, IMAGE_PRESETS.product);

        const formData = new FormData();
        formData.append('file', picFile)
        formData.append('assetName',payload.picName)
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const res = await axios.post("/assets/picture/upload", formData,config)
        if (res.data.status == "Error") {
            toast.error(res.data.message);
            dispatch(failturePictures(res.data.message));
        } else {
            const data = await getStorePictures();
            if (data.status == 'Ok') {
                const payload = {
                    pictures: data.pictures
                }
                dispatch(receivedPictures(payload));
            } else {
                toast.error(data.message);
                dispatch(failturePictures(data.message));
            }
            toast.success("A Picture has been uploaded!");
        }
    }
}

async function updateAssetName(assetId, assetName) {
    const response = await axios.put(`/api/assets/${assetId}/rename/${assetName}`);
    return response.data;
}

export function updatePicture(payload) {
    return async (dispatch) => {
        dispatch(updatingPictures());
        var assetId =  payload.AssetId;
        var assetName =  payload.Name;

        var res = await updateAssetName(assetId, assetName)
        if (res.status == 'Ok') {
            const data = await getStorePictures();
            if (data.status == 'Ok') {
                const payload = {
                    pictures: data.pictures
                }
                dispatch(receivedPictures(payload));
            } else {
                toast.error(data.message);
                dispatch(failturePictures(data.message));
            }
            toast.success("The name of the picture has been updated!");
        } else {
            dispatch(failturePictures(res.message));
        }
    };
}

async function deleteAsset(assetId) {
    const response = await axios.delete(`/api/assets/${assetId}/delete/force`);
    return response.data;
}

export function deletePicture(id) {
    return async (dispatch) => {
        dispatch(deletingPictures(id));
        try {
            var res = await deleteAsset(id)
            if (res.status == 'Ok') {
                const data = await getStorePictures();
                if (data.status == 'Ok') {
                    const payload = {
                        pictures: data.pictures
                    }
                    dispatch(receivedPictures(payload));
                } else {
                    toast.error(data.message);
                    dispatch(failturePictures(data.message));
                    return;
                }
                toast.success("The picture has been deleted!");
            } else {
                toast.error(res.message || 'Failed to delete the picture.');
                dispatch(failturePictures(res.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to delete the picture.';
            toast.error(message);
            dispatch(failturePictures(message));
        }
    };
}

async function getStoreVideos() {
    const response = await axios.get(`/api/assets/store/video`);
    return response.data;
}

export function loadVideos() {
    return async (dispatch) => {
        dispatch(receivingVideos());
        
        const data = await getStoreVideos()
        console.log("store video data")
        console.log(data)
        if (data.status == 'Ok') {
            const payload = {
                videos: data.video
            }
            dispatch(receivedVideos(payload));
        } else {
            toast.error(data.message);
            dispatch(failtureVideos(data.message));
        }
    };
}

export function createVideo(payload) {
    return async (dispatch) => {
        
        dispatch(updatingVideos());

        const posterFile = await normalizeUploadImage(payload.posterFile, IMAGE_PRESETS.product);

        const formData = new FormData();
        formData.append('videoFile',payload.videoFile)
        formData.append('posterFile', posterFile)
        formData.append('assetName',payload.videoName)
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const res = await axios.post("/assets/video/upload", formData,config)
        if (res.data.status == "Error") {
            toast.error(res.data.message);
            dispatch(failtureVideos(res.data.message));
        } else {
            const data = await getStoreVideos();
            if (data.status == 'Ok') {
                const payload = {
                    videos: data.video
                }
                dispatch(receivedVideos(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureVideos(data.message));
            }
            toast.success("A video has been uploaded!");
        }
    }
}

export function updateVideo(payload) {
    return async (dispatch) => {
        dispatch(updatingVideos());
        var assetId =  payload.AssetId;
        var assetName =  payload.Name;

        var res = await updateAssetName(assetId, assetName)
        if (res.status == 'Ok') {
            const data = await getStoreVideos();
            if (data.status == 'Ok') {
                const payload = {
                    videos: data.video
                }
                dispatch(receivedVideos(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureVideos(data.message));
            }
            toast.success("The name of the video has been updated!");
        } else {
            dispatch(failtureVideos(res.message));
        }
    };
}

export function deleteVideo(id) {
    return async (dispatch) => {
        dispatch(deletingVideos(id));
        try {
            var res = await deleteAsset(id)
            if (res.status == 'Ok') {
                const data = await getStoreVideos();
                if (data.status == 'Ok') {
                    const payload = {
                        videos: data.video
                    }
                    dispatch(receivedVideos(payload));
                } else {
                    toast.error(data.message);
                    dispatch(failtureVideos(data.message));
                    return;
                }
                toast.success("The video has been deleted!");
            } else {
                toast.error(res.message || 'Failed to delete the video.');
                dispatch(failtureVideos(res.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to delete the video.';
            toast.error(message);
            dispatch(failtureVideos(message));
        }
    };
}

async function getStoreWebsites() {
    const response = await axios.get(`/api/assets/store/websites`);
    return response.data;
}

export function loadWebsites() {
    return async (dispatch) => {
        dispatch(receivingWebsites());
        
        const data = await getStoreWebsites()
        console.log("store website data")
        console.log(data)
        if (data.status == 'Ok') {
            const payload = {
                websites: data.websites
            }
            dispatch(receivedWebsites(payload));
        } else {
            toast.error(data.message);
            dispatch(failtureWebsites(data.message));
        }
    };
}

export function createWebsite(payload) {
    return async (dispatch) => {
        
        dispatch(updatingWebsites());

        console.log("create website payload")
        console.log(payload)

        const res = await axios.post("api/assets/store/website/add", payload)
        if (res.data.status == "Error") {
            toast.error(res.data.message);
            dispatch(failtureWebsites(res.data.message));
        } else {
            const data = await getStoreWebsites();
            if (data.status == 'Ok') {
                const payload = {
                    websites: data.websites
                }
                dispatch(receivedWebsites(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureWebsites(data.message));
            }
            toast.success("A website has been added!");
        }
    }
}

export function updateWebsite(payload) {
    return async (dispatch) => {
        dispatch(updatingWebsites());
        
        var res = await axios.put('/api/assets/store/website/update', payload);
        if (res.data.status == 'Ok') {
            const data = await getStoreWebsites();
            if (data.status == 'Ok') {
                const payload = {
                    websites: data.websites
                }
                dispatch(receivedWebsites(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureWebsites(data.message));
            }
            toast.success("The website has been updated!");
        } else {
            dispatch(failtureWebsites(res.data.message));
        }
    };
}

export function deleteWebsite(id) {
    return async (dispatch) => {
        dispatch(deletingWebsites(id));
        try {
            var res = await deleteAsset(id)
            if (res.status == 'Ok') {
                const data = await getStoreWebsites();
                if (data.status == 'Ok') {
                    const payload = {
                        websites: data.websites
                    }
                    dispatch(receivedWebsites(payload));
                } else {
                    toast.error(data.message);
                    dispatch(failtureWebsites(data.message));
                    return;
                }
                toast.success("The website has been deleted!");
            } else {
                toast.error(res.message || 'Failed to delete the website.');
                dispatch(failtureWebsites(res.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to delete the website.';
            toast.error(message);
            dispatch(failtureWebsites(message));
        }
    };
}

export function loadStationSettings() {
    return async (dispatch) => {
        dispatch(receivingStationSettings());
        
        var data = await getStoreWebsites()
        console.log("store website data")
        console.log(data)
        if (data.status == 'Ok') {
            var websites = data.websites;
            var videos = [];
            var pictures = [];
            data = await getStoreVideos();
            console.log("store video data")
            console.log(data)
            if (data.status == 'Ok') {
                videos = data.video;

                data = await getStorePictures();
                console.log("store picture data")
                console.log(data)
                if (data.status == 'Ok') {
                    pictures = data.pictures;
                } else {
                    toast.error(data.message);
                    dispatch(failtureStationSettings(data.message));
                }
            } else {
                toast.error(data.message);
                dispatch(failtureStationSettings(data.message));
            }

            const payload = {
                websites,
                videos,
                pictures
            }

            dispatch(receivedStationSettings(payload));

        } else {
            toast.error(data.message);
            dispatch(failtureStationSettings(data.message));
        }
    };
}

async function getCategories(merchantId) {
    const response = await axios.get(`/api/products/categories/${merchantId}`);
    const categories = Array.isArray(response.data.categories) ? response.data.categories : [];
    return categories.map(normalizeCategory);
}

async function getProductDefaults(merchantId) {
    const response = await axios.get(`/api/product/defaults/merchant/${merchantId}`);
    return response.data;
}

async function getStoreDetails() {
    const response = await axios.get(`/api/store/detail`);
    return response.data;
}

function normalizeTipPayoutRoutingMode(value) {
    const parsed = Number(value);
    return parsed === 1 || parsed === 2 || parsed === 3 ? parsed : 3;
}

function normalizeStoreDetails(storeDetails) {
    if (!storeDetails) {
        return storeDetails;
    }

    return {
        ...storeDetails,
        TipPayoutRoutingMode: normalizeTipPayoutRoutingMode(storeDetails.TipPayoutRoutingMode)
    };
}

export function loadStoreDetails() {
    return async (dispatch) => {
        dispatch(receivingStoreDetails());

        try {
            const data = await getStoreDetails();
            if (data.status == 'Ok') {
                const payload = {
                    storeDetails: normalizeStoreDetails(data.storeDetails),
                    states: data.states
                }

                try {
                    const categories = await getCategories(payload.storeDetails.MerchantId);
                    dispatch({
                        type: RECEIVED_CATEGORIES,
                        payload: { categories },
                    });
                } catch (err) {
                    toast.error(err?.response?.data?.message || err.message || 'Failed to load categories.');
                }

                try {
                    const prodDefaults = await getProductDefaults(data.storeDetails.MerchantId);
                    if (prodDefaults.status == 'Ok') {
                        dispatch(receivedProductDefaults({
                            productDefaults: prodDefaults.defaults
                        }));
                    }
                } catch (err) {
                    toast.error(err?.response?.data?.message || err.message || 'Failed to load product defaults.');
                }

                dispatch(receivedStoreDetails(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureStoreDetails(data.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to load store details.';
            toast.error(message);
            dispatch(failtureStoreDetails(message));
        }
    };
}

export function updateStoreDetails(payload) {
    return async (dispatch) => {
        dispatch(updatingStoreDetails());

        try {
            const normalizedPayload = normalizeStoreDetails(payload);
            var res = await axios.post('/api/store/update', normalizedPayload);
            if (res.data.status == 'Ok') {
                const data = await getStoreDetails()
                if (data.status == 'Ok') {
                    dispatch(receivedStoreDetails({
                        storeDetails: normalizeStoreDetails(data.storeDetails),
                        states: data.states
                    }));
                } else {
                    toast.error(data.message);
                    dispatch(failtureStoreDetails(data.message));
                }
            } else {
                toast.error(res.data.message);
                dispatch(failtureStoreDetails(res.data.message));
            }
        } catch (err) {
            const message = err?.response?.data?.message || err.message || 'Failed to save store details.';
            toast.error(message);
            dispatch(failtureStoreDetails(message));
        }
    };
}

async function uploadStorePicture(picFile) {
    const normalized = await normalizeUploadImage(picFile, IMAGE_PRESETS.product);
    const formData = new FormData();
    formData.append('file', normalized)
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    const response = await axios.post("/store/picture/upload", formData,config)

    return response;
}

export function updateStorePicture(payload) {
    return async (dispatch) => {
        dispatch(updatingStoreDetails());
        
        var res = await uploadStorePicture(payload);
        if (res.data.status == 'Ok') {
            const data = await getStoreDetails()
            console.log("upload store image data");
            console.log(data);
            if (data.status == 'Ok') {
                const payload = {
                    storeDetails: normalizeStoreDetails(data.storeDetails),
                    states: data.states
                }
                dispatch(receivedStoreDetails(payload));
            } else {
                toast.error(data.message);
                dispatch(failtureStoreDetails(data.message));
            }
        } else {
            dispatch(failtureStoreDetails(res.data.message));
        }
    };
}

export function createProductDefaults(payload) {
    return async (dispatch) => {
        
        dispatch(updatingProductDefaults());

        const res = await axios.post("api/product/defaults", payload)
        if (res.data.status == "Error") {
            toast.error(res.data.message);
            dispatch(failtureProductDefaults(res.data.message));
        } else {
            const data = await getProductDefaults(payload.MerchantId);
            if (data.status == 'Ok') {
                const prod_payload = {
                    productDefaults: data.defaults
                }
                dispatch(receivedProductDefaults(prod_payload));
            } else {
                toast.error(data.message);
                dispatch(failtureProductDefaults(data.message));
            }
            toast.success("Product defaults has been added!");
        }
    }
}

export function updateProductDefaults(payload) {
    return async (dispatch) => {
        
        dispatch(updatingProductDefaults());

        const res = await axios.put("api/product/defaults/update", payload)
        if (res.data.status == "Error") {
            toast.error(res.data.message);
            dispatch(failtureProductDefaults(res.data.message));
        } else {
            const data = await getProductDefaults(payload.MerchantId);
            if (data.status == 'Ok') {
                const prod_payload = {
                    productDefaults: data.defaults
                }
                dispatch(receivedProductDefaults(prod_payload));
            } else {
                toast.error(data.message);
                dispatch(failtureProductDefaults(data.message));
            }
            toast.success("Product defaults has been updated!");
        }
    }
}

export function bulkApplyProductFeeOption({ feeOption, merchantId }) {
    return async (dispatch) => {
        try {
            const res = await axios.put('api/product/bulk/apply-fee-option', {
                FeeOption: Number(feeOption),
            });

            if (res.data.status === 'Error') {
                toast.error(res.data.message);
                return false;
            }

            const count = res.data.updatedCount || 0;
            toast.success(`Updated card fee option on ${count} product${count === 1 ? '' : 's'}.`);

            if (merchantId) {
                dispatch(getProductsRequest(merchantId));
            }

            return true;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to apply card fee option to products.';
            toast.error(message);
            return false;
        }
    };
}

export function bulkApplyProductTaxRate({ taxRate, merchantId }) {
    return async (dispatch) => {
        try {
            const res = await axios.put('api/product/bulk/apply-tax-rate', {
                TaxRate: Number(taxRate),
            });

            if (res.data.status === 'Error') {
                toast.error(res.data.message);
                return false;
            }

            const count = res.data.updatedCount || 0;
            toast.success(`Updated tax rate on ${count} product${count === 1 ? '' : 's'}.`);

            if (merchantId) {
                dispatch(getProductsRequest(merchantId));
            }

            return true;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to apply tax rate to products.';
            toast.error(message);
            return false;
        }
    };
}

// Force-clocks-out any users still active in already-ended work periods,
// across all stores the authenticated merchant owns. Returns the count of
// reconciled user sessions, or throws on failure.
export function reconcileWorkPeriods() {
    return async () => {
        try {
            const res = await axios.post("/api/admin/workperiods/reconcile");
            if (res.data.status === "Ok") {
                const count = res.data.reconciledCount || 0;
                if (count > 0) {
                    toast.success(`Reconciled ${count} user session${count === 1 ? '' : 's'}.`);
                } else {
                    toast.info("No active users found in ended work periods.");
                }
                return count;
            }
            const message = res.data.message || "Failed to reconcile work periods.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to reconcile work periods.";
            toast.error(message);
            throw error;
        }
    };
}

function normalizeSystemSettings(raw) {
    if (!raw) {
        return {
            autoSendEmployeeShiftReportSms: false,
            autoSendEmployeeShiftReportEmail: false,
            autoSendEmployeePayoutSms: false,
            pooledTips: false,
            displayLanguage: DEFAULT_LANGUAGE,
            smsDeliveryConfigured: false,
            emailDeliveryConfigured: false,
        };
    }

    return {
        autoSendEmployeeShiftReportSms: !!(raw.autoSendEmployeeShiftReportSms ?? raw.AutoSendEmployeeShiftReportSms),
        autoSendEmployeeShiftReportEmail: !!(raw.autoSendEmployeeShiftReportEmail ?? raw.AutoSendEmployeeShiftReportEmail),
        autoSendEmployeePayoutSms: !!(raw.autoSendEmployeePayoutSms ?? raw.AutoSendEmployeePayoutSms),
        pooledTips: !!(raw.pooledTips ?? raw.PooledTips),
        displayLanguage: normalizeLanguage(raw.displayLanguage ?? raw.DisplayLanguage) || DEFAULT_LANGUAGE,
        smsDeliveryConfigured: !!(raw.smsDeliveryConfigured ?? raw.SmsDeliveryConfigured),
        emailDeliveryConfigured: !!(raw.emailDeliveryConfigured ?? raw.EmailDeliveryConfigured),
    };
}

export function loadSystemSettingsRequest(options = {}) {
    return async () => {
        try {
            const res = await axios.get("/api/admin/system-settings");
            if (res.data?.status === "Ok" && res.data.settings) {
                return normalizeSystemSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to load system settings.";
            if (!options.quiet) {
                toast.error(message);
            }
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to load system settings.";
            if (!options.quiet) {
                toast.error(message);
            }
            throw error;
        }
    };
}

export function saveSystemSettingsRequest(payload) {
    return async () => {
        try {
            const res = await axios.put("/api/admin/system-settings", payload);
            if (res.data?.status === "Ok" && res.data.settings) {
                toast.success("System settings saved.");
                return normalizeSystemSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to save system settings.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to save system settings.";
            toast.error(message);
            throw error;
        }
    };
}

function normalizePayrollSettings(raw) {
    if (!raw) {
        return {
            payrollEnabled: false,
            includeTipsAndGratuityInPayroll: false,
            payrollEngineConnected: false,
            payrollEngineStatusMessage: '',
        };
    }

    return {
        payrollEnabled: !!(raw.payrollEnabled ?? raw.PayrollEnabled),
        includeTipsAndGratuityInPayroll: !!(raw.includeTipsAndGratuityInPayroll ?? raw.IncludeTipsAndGratuityInPayroll),
        payrollEngineConnected: !!(raw.payrollEngineConnected ?? raw.PayrollEngineConnected),
        payrollEngineStatusMessage: raw.payrollEngineStatusMessage ?? raw.PayrollEngineStatusMessage ?? '',
    };
}

function normalizePayrollEngine(raw) {
    if (!raw) {
        return {
            baseUrl: '',
            apiKeyConfigured: false,
            configured: false,
            connected: false,
            message: '',
            detail: '',
        };
    }

    return {
        baseUrl: raw.baseUrl ?? raw.BaseUrl ?? '',
        apiKeyConfigured: !!(raw.apiKeyConfigured ?? raw.ApiKeyConfigured),
        configured: !!(raw.configured ?? raw.Configured),
        connected: !!(raw.connected ?? raw.Connected),
        message: raw.message ?? raw.Message ?? '',
        detail: raw.detail ?? raw.Detail ?? '',
    };
}

export function loadPayrollEngineRequest() {
    return async () => {
        try {
            const res = await axios.get('/api/admin/payroll-engine');
            if (res.data?.status === 'Ok' && res.data.engine) {
                return normalizePayrollEngine(res.data.engine);
            }
            const message = res.data?.message || 'Failed to load Payroll Engine settings.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to load Payroll Engine settings.';
            toast.error(message);
            throw error;
        }
    };
}

export function savePayrollEngineRequest(payload) {
    return async () => {
        try {
            const res = await axios.put('/api/admin/payroll-engine', payload);
            if (res.data?.status === 'Ok' && res.data.engine) {
                toast.success(res.data.engine.connected
                    ? 'Payroll Engine connected.'
                    : 'Payroll Engine settings saved.');
                return normalizePayrollEngine(res.data.engine);
            }
            const message = res.data?.message || 'Failed to save Payroll Engine settings.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to save Payroll Engine settings.';
            toast.error(message);
            throw error;
        }
    };
}

export function loadPayrollSettingsRequest() {
    return async () => {
        try {
            const res = await axios.get("/api/admin/payroll-settings");
            if (res.data?.status === "Ok" && res.data.settings) {
                return normalizePayrollSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to load payroll settings.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to load payroll settings.";
            toast.error(message);
            throw error;
        }
    };
}

export function savePayrollSettingsRequest(payload) {
    return async () => {
        try {
            const res = await axios.put("/api/admin/payroll-settings", payload);
            if (res.data?.status === "Ok" && res.data.settings) {
                toast.success("Payroll settings saved.");
                return normalizePayrollSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to save payroll settings.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to save payroll settings.";
            toast.error(message);
            throw error;
        }
    };
}

function normalizeStripeTaxSettings(raw) {
    if (!raw) {
        return {
            stripeTaxEnabled: false,
            offlineTaxMode: 'TaxApi',
            reserveTaxSource: 'StripeTaxNet',
            defaultTaxCode: 'txcd_40060003',
            foodTaxCode: 'txcd_40060003',
            alcoholTaxCode: 'txcd_40040000',
            merchandiseTaxCode: 'txcd_99999999',
            businessCountry: 'US',
            businessState: 'GA',
            businessCity: 'Atlanta',
            businessPostalCode: '30303',
            businessLine1: '1 Peachtree St',
        };
    }

    return {
        stripeTaxEnabled: !!(raw.stripeTaxEnabled ?? raw.StripeTaxEnabled),
        offlineTaxMode: raw.offlineTaxMode ?? raw.OfflineTaxMode ?? 'TaxApi',
        reserveTaxSource: raw.reserveTaxSource ?? raw.ReserveTaxSource ?? 'StripeTaxNet',
        defaultTaxCode: raw.defaultTaxCode ?? raw.DefaultTaxCode ?? 'txcd_40060003',
        foodTaxCode: raw.foodTaxCode ?? raw.FoodTaxCode ?? 'txcd_40060003',
        alcoholTaxCode: raw.alcoholTaxCode ?? raw.AlcoholTaxCode ?? 'txcd_40040000',
        merchandiseTaxCode: raw.merchandiseTaxCode ?? raw.MerchandiseTaxCode ?? 'txcd_99999999',
        businessCountry: raw.businessCountry ?? raw.BusinessCountry ?? 'US',
        businessState: raw.businessState ?? raw.BusinessState ?? 'GA',
        businessCity: raw.businessCity ?? raw.BusinessCity ?? 'Atlanta',
        businessPostalCode: raw.businessPostalCode ?? raw.BusinessPostalCode ?? '30303',
        businessLine1: raw.businessLine1 ?? raw.BusinessLine1 ?? '1 Peachtree St',
    };
}

function normalizeStripeTaxStatus(raw) {
    if (!raw) {
        return {
            stripeTaxEnabled: false,
            connectedAccountPresent: false,
            stripeAccountId: '',
            activeRegistrationCount: 0,
            message: '',
            offlineTaxMode: 'TaxApi',
            reserveTaxSource: 'StripeTaxNet',
            ledgerTaxNet: 0,
        };
    }

    return {
        stripeTaxEnabled: !!(raw.stripeTaxEnabled ?? raw.StripeTaxEnabled),
        connectedAccountPresent: !!(raw.connectedAccountPresent ?? raw.ConnectedAccountPresent),
        stripeAccountId: raw.stripeAccountId ?? raw.StripeAccountId ?? '',
        activeRegistrationCount: Number(raw.activeRegistrationCount ?? raw.ActiveRegistrationCount ?? 0) || 0,
        message: raw.message ?? raw.Message ?? '',
        offlineTaxMode: raw.offlineTaxMode ?? raw.OfflineTaxMode ?? 'TaxApi',
        reserveTaxSource: raw.reserveTaxSource ?? raw.ReserveTaxSource ?? 'StripeTaxNet',
        ledgerTaxNet: Number(raw.ledgerTaxNet ?? raw.LedgerTaxNet ?? 0) || 0,
    };
}

export function loadStripeTaxSettingsRequest() {
    return async () => {
        try {
            const res = await axios.get('/api/admin/stripe-tax-settings');
            if (res.data?.status === 'Ok') {
                return {
                    settings: normalizeStripeTaxSettings(res.data.settings),
                    taxStatus: normalizeStripeTaxStatus(res.data.taxStatus),
                };
            }
            const message = res.data?.message || 'Failed to load Stripe Tax settings.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to load Stripe Tax settings.';
            toast.error(message);
            throw error;
        }
    };
}

export function loadProductStripeTaxCodeRequest(productId) {
    return async () => {
        if (!productId) {
            return null;
        }

        try {
            const res = await axios.get(`/api/admin/stripe-tax/product-tax-code/${productId}`);
            if (res.data?.status === 'Ok') {
                return res.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    };
}

export function saveProductStripeTaxCodeRequest(productId, taxCode) {
    return async () => {
        if (!productId) {
            return null;
        }

        try {
            const res = await axios.put('/api/admin/stripe-tax/product-tax-code', {
                ProductId: productId,
                TaxCode: taxCode || '',
            });
            return res.data;
        } catch (error) {
            return null;
        }
    };
}

export function saveStripeTaxSettingsRequest(payload) {
    return async () => {
        try {
            const res = await axios.put('/api/admin/stripe-tax-settings', payload);
            if (res.data?.status === 'Ok' && res.data.settings) {
                toast.success('Stripe Tax settings saved.');
                return {
                    settings: normalizeStripeTaxSettings(res.data.settings),
                    taxStatus: normalizeStripeTaxStatus(res.data.taxStatus),
                };
            }
            const message = res.data?.message || 'Failed to save Stripe Tax settings.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Failed to save Stripe Tax settings.';
            toast.error(message);
            throw error;
        }
    };
}

export function calculateStripeTaxRequest(payload) {
    return async () => {
        try {
            const res = await axios.post('/api/admin/stripe-tax/calculate', payload);
            if (res.data?.status === 'Ok') {
                return res.data;
            }
            const message = res.data?.message || 'Stripe Tax calculation failed.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Stripe Tax calculation failed.';
            toast.error(message);
            throw error;
        }
    };
}

export function recordStripeTaxRemittanceRequest(payload) {
    return async () => {
        try {
            const res = await axios.post('/api/admin/stripe-tax/remittance', payload);
            if (res.data?.status === 'Ok') {
                toast.success(res.data.message || 'Remittance recorded.');
                return res.data;
            }
            const message = res.data?.message || 'Remittance failed.';
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Remittance failed.';
            toast.error(message);
            throw error;
        }
    };
}

export function loadStripeTaxFilingRequest() {
    return async () => {
        try {
            const res = await axios.get('/api/admin/stripe-tax/filing');
            if (res.data?.status === 'Ok') {
                return res.data;
            }
            throw new Error(res.data?.message || 'Could not load Stripe Tax filing info.');
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || 'Could not load Stripe Tax filing info.';
            throw new Error(message);
        }
    };
}

const DEFAULT_ORDER_COMPLETE_MESSAGE = "Your order is ready";

function normalizeMerchantNotificationSettings(raw) {
    if (!raw) {
        return {
            enableQuickServeFlowDefault: false,
            autoNotifySmsOnOrderCompleteDefault: false,
            autoNotifyEmailOnOrderCompleteDefault: false,
            defaultOrderCompleteMessage: DEFAULT_ORDER_COMPLETE_MESSAGE,
        };
    }

    const message = raw.defaultOrderCompleteMessage ?? raw.DefaultOrderCompleteMessage;
    const trimmedMessage = typeof message === "string" ? message.trim() : "";

    return {
        enableQuickServeFlowDefault: !!(raw.enableQuickServeFlowDefault ?? raw.EnableQuickServeFlowDefault),
        autoNotifySmsOnOrderCompleteDefault: !!(raw.autoNotifySmsOnOrderCompleteDefault ?? raw.AutoNotifySmsOnOrderCompleteDefault),
        autoNotifyEmailOnOrderCompleteDefault: !!(raw.autoNotifyEmailOnOrderCompleteDefault ?? raw.AutoNotifyEmailOnOrderCompleteDefault),
        defaultOrderCompleteMessage: trimmedMessage || DEFAULT_ORDER_COMPLETE_MESSAGE,
    };
}

export function loadMerchantNotificationSettingsRequest() {
    return async () => {
        try {
            const res = await axios.get("/api/admin/notification-settings");
            if (res.data?.status === "Ok" && res.data.settings) {
                return normalizeMerchantNotificationSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to load customer notification settings.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to load customer notification settings.";
            toast.error(message);
            throw error;
        }
    };
}

export function saveMerchantNotificationSettingsRequest(payload) {
    return async () => {
        try {
            const res = await axios.put("/api/admin/notification-settings", {
                EnableQuickServeFlowDefault: payload.enableQuickServeFlowDefault,
                AutoNotifySmsOnOrderCompleteDefault: payload.autoNotifySmsOnOrderCompleteDefault,
                AutoNotifyEmailOnOrderCompleteDefault: payload.autoNotifyEmailOnOrderCompleteDefault,
                DefaultOrderCompleteMessage: payload.defaultOrderCompleteMessage,
            });
            if (res.data?.status === "Ok" && res.data.settings) {
                toast.success("Customer notification defaults saved.");
                return normalizeMerchantNotificationSettings(res.data.settings);
            }
            const message = res.data?.message || "Failed to save customer notification settings.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to save customer notification settings.";
            toast.error(message);
            throw error;
        }
    };
}

export function resetStationNotificationSettingsRequest() {
    return async () => {
        try {
            const res = await axios.post("/api/admin/notification-settings/reset-stations");
            if (res.data?.status === "Ok") {
                const resetCount = res.data.resetCount ?? 0;
                toast.success(
                    resetCount === 1
                        ? "Reset notification overrides on 1 station."
                        : `Reset notification overrides on ${resetCount} stations.`
                );
                return resetCount;
            }
            const message = res.data?.message || "Failed to reset station notification overrides.";
            toast.error(message);
            throw new Error(message);
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Failed to reset station notification overrides.";
            toast.error(message);
            throw error;
        }
    };
}

export function receivingStations() {
    return {
        type: RECEIVING_STATIONS
    }
}

export function updatingStations() {
    return {
        type: UPDATING_STATIONS
    }
}

export function deletingStations(stationId) {
    return {
        type: DELETING_STATIONS,
        payload: stationId
    }
}

export function receivedStations(payload) {
    return {
        type: RECEIVED_STATIONS,
        payload
    }
}

export function failtureStations(payload) {
    return {
        type: FAILURE_STATIONS,
        payload
    }
}

export function receivingPictures() {
    return {
        type: RECEIVING_PICTURES
    }
}

export function updatingPictures() {
    return {
        type: UPDATING_PICTURES
    }
}

export function deletingPictures(payload) {
    return {
        type: DELETING_PICTURES,
        payload
    }
}

export function receivedPictures(payload) {
    return {
        type: RECEIVED_PICTURES,
        payload
    }
}

export function failturePictures(payload) {
    return {
        type: FAILURE_PICTURES,
        payload
    }
}

export function receivingVideos() {
    return {
        type: RECEIVING_VIDEOS
    }
}

export function updatingVideos() {
    return {
        type: UPDATING_VIDEOS
    }
}

export function deletingVideos(payload) {
    return {
        type: DELETING_VIDEOS,
        payload
    }
}

export function receivedVideos(payload) {
    return {
        type: RECEIVED_VIDEOS,
        payload
    }
}

export function failtureVideos(payload) {
    return {
        type: FAILURE_VIDEOS,
        payload
    }
}

export function receivingWebsites() {
    return {
        type: RECEIVING_WEBSITES
    }
}

export function updatingWebsites() {
    return {
        type: UPDATING_WEBSITES
    }
}

export function deletingWebsites(payload) {
    return {
        type: DELETING_WEBSITES,
        payload
    }
}

export function receivedWebsites(payload) {
    return {
        type: RECEIVED_WEBSITES,
        payload
    }
}

export function failtureWebsites(payload) {
    return {
        type: FAILURE_WEBSITES,
        payload
    }
}

export function receivingStationSettings() {
    return {
        type: RECEIVING_STATION_SETTINGS
    }
}

export function receivedStationSettings(payload) {
    return {
        type: RECEIVED_STATION_SETTINGS,
        payload
    }
}

export function failtureStationSettings(payload) {
    return {
        type: FAILURE_STATION_SETTINGS,
        payload
    }
}

export function receivingStoreDetails() {
    return {
        type: RECEIVING_STORE_DETAILS
    }
}

export function updatingStoreDetails() {
    return {
        type: UPDATING_STORE_DETAILS
    }
}

export function receivedStoreDetails(payload) {
    return {
        type: RECEIVED_STORE_DETAILS,
        payload
    }
}

export function failtureStoreDetails(payload) {
    return {
        type: FAILURE_STORE_DETAILS,
        payload
    }
}

export function updatingProductDefaults() {
    return {
        type: UPDATING_PRODUCT_DEFAULTS
    }
}

export function receivedProductDefaults(payload) {
    return {
        type: RECEIVED_PRODUCT_DEFAULTS,
        payload
    }
}

export function failtureProductDefaults(payload) {
    return {
        type: FAILURE_PRODUCT_DEFAULTS,
        payload
    }
}